/* ==========================================================================
   ac-reveal.js — Revelado suave al hacer scroll.
   --------------------------------------------------------------------------
   Diseñado a la defensiva por dos motivos ya sufridos en este proyecto:

   1. El panel de navegador integrado no compone fotogramas: los observadores
      no disparan y las transiciones se quedan en su valor inicial. Por eso el
      CSS deja los elementos VISIBLES por defecto y solo los oculta cuando este
      script añade `ac-js` al <html>, es decir, cuando ya ha comprobado que
      IntersectionObserver existe.
   2. Una espera sin tope es una promesa rota. Si por lo que sea el observador
      no llega a disparar, a los 1.500 ms se revela todo igualmente.

   No hay ningún testigo que se quede en `true` antes de una promesa: aquí no
   hay promesas. Todo es síncrono y con salida garantizada.

   2026-08-11 — DOS NOMBRES DE CLASE, NO UNO
   Este script solo miraba `.ac-rev`, pero las catorce secciones narrativas
   marcan sus elementos con `.ac-reveal`. Es decir: en toda la web, lo único
   que se animaba era la ficha de producto. Ahora atiende a las dos, y
   `ac-system.css` define el mismo comportamiento para ambas.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document.documentElement;

  var soportado =
    'IntersectionObserver' in window &&
    typeof window.matchMedia === 'function' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!soportado) return; // Se queda todo visible. Es el estado correcto.

  doc.classList.add('ac-js');

  var revelarTodo = function () {
    var pendientes = document.querySelectorAll('.ac-rev:not(.is-in), .ac-reveal:not(.is-in)');
    for (var i = 0; i < pendientes.length; i++) pendientes[i].classList.add('is-in');
  };

  // Red de seguridad: si el observador no llega a montarse, a los 1.500 ms no
  // queda nada oculto.
  var plazo = window.setTimeout(revelarTodo, 1500);

  // Testigo de que el observador SÍ funciona. Ver más abajo por qué importa.
  var haDisparado = false;

  var arrancar = function () {
    var objetivos = document.querySelectorAll('.ac-rev, .ac-reveal');
    if (!objetivos.length) return;

    var observador = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].isIntersecting) continue;
          haDisparado = true;
          entradas[i].target.classList.add('is-in');
          observador.unobserve(entradas[i].target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var i = 0; i < objetivos.length; i++) {
      // Lo que ya está en pantalla al cargar se revela sin esperar al scroll:
      // si no, la primera pantalla aparecería vacía durante un instante.
      var caja = objetivos[i].getBoundingClientRect();
      if (caja.top < window.innerHeight * 0.92) {
        // Lo que ya se ve al cargar también entra animado, en el siguiente
        // fotograma: si se le pone `is-in` en el mismo, el navegador no llega
        // a ver el estado inicial y no hay transición que interpolar.
        (function (el, orden) {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              el.classList.add('is-in');
            });
          });
        })(objetivos[i], i);
      } else {
        observador.observe(objetivos[i]);
      }
    }

    window.clearTimeout(plazo);

    // ------------------------------------------------------------------
    // CORREGIDO EL 2026-08-11 — la red de seguridad se comía las animaciones
    // ------------------------------------------------------------------
    // Antes esto era un `setTimeout(revelarTodo, 6000)` incondicional: a los
    // seis segundos se revelaba TODA la página, hubiera o no hecho scroll el
    // visitante. Y seis segundos es menos de lo que tarda cualquiera en bajar
    // por una ficha de producto larga, así que en la práctica no se animaba
    // nada: todo aparecía ya puesto. Es lo que Marco veía.
    //
    // La protección sigue —un navegador donde el observador no dispare no
    // puede quedarse con media página invisible— pero ahora solo actúa si el
    // observador NO ha dado señales de vida. Si ha disparado al menos una vez,
    // funciona, y entonces no hay nada de lo que proteger.
    window.setTimeout(function () {
      if (haDisparado) return;
      revelarTodo();
    }, 6000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas por AJAX: hay que volver a
  // pasar por los elementos nuevos o se quedarían ocultos dentro del editor.
  document.addEventListener('shopify:section:load', arrancar);
})();
